import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewTaskFileService } from './review-task-file/review-task-file.service';
import { CancelTaskFileReviewService } from './cancel-task-file-review/cancel-task-file-review.service';
import { ConvertTaskFileIntoTaskInternalFileService } from './convert-task-file-into-task-internal-file/convert-task-file-into-task-internal-file.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    ConvertTaskFileIntoTaskInternalFileService,
    ReviewTaskFileService,
    CancelTaskFileReviewService
  ],
})
export class TaskFilesModule {}
